import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import "./candidate-list-filter-prompt.scss";

const DEFAULT_STEPS = ["Choose filters", "Click Search", "View results"];

const CandidateListFilterPrompt = ({
  title = "Apply filters to view data",
  description = "Set your criteria using the filters above, then click Search to load results.",
  onSearch,
  searchLabel = "Search now",
  steps = DEFAULT_STEPS,
  variant = "standalone",
}) => {
  const visibleSteps = (Array.isArray(steps) ? steps : []).filter(Boolean);
  const isTableVariant = variant === "table";

  return (
    <div
      className={[
        "candidate-list-filter-prompt",
        isTableVariant ? "candidate-list-filter-prompt--table" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      role="status"
      aria-live="polite"
    >
      <div className="candidate-list-filter-prompt__card">
        {isTableVariant ? (
          <div className="candidate-list-filter-prompt__decor candidate-list-filter-prompt__decor--left" aria-hidden />
        ) : null}
        {isTableVariant ? (
          <div className="candidate-list-filter-prompt__decor candidate-list-filter-prompt__decor--right" aria-hidden />
        ) : null}

        <div className="candidate-list-filter-prompt__inner">
          <div className="candidate-list-filter-prompt__icon-wrap" aria-hidden>
            <i className="bx bx-filter-alt candidate-list-filter-prompt__icon" />
          </div>

          <div className="candidate-list-filter-prompt__content">
            <h6 className="candidate-list-filter-prompt__title">{title}</h6>
            <p className="candidate-list-filter-prompt__description">{description}</p>
          </div>

          {/* {visibleSteps.length ? (
            <div className="candidate-list-filter-prompt__steps">
              {visibleSteps.map((step, index) => (
                <span key={step} className="candidate-list-filter-prompt__step">
                  <span className="candidate-list-filter-prompt__step-num">{index + 1}</span>
                  {step}
                  {index < visibleSteps.length - 1 ? (
                    <i className="bx bx-chevron-right" aria-hidden />
                  ) : null}
                </span>
              ))}
            </div>
          ) : null}

          {typeof onSearch === "function" ? (
            <Button
              color="primary"
              className="candidate-list-filter-prompt__cta"
              onClick={onSearch}
            >
              <i className="bx bx-search-alt me-1" aria-hidden />
              {searchLabel}
            </Button>
          ) : null} */}
        </div>
      </div>
    </div>
  );
};

CandidateListFilterPrompt.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onSearch: PropTypes.func,
  searchLabel: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.string),
  variant: PropTypes.oneOf(["standalone", "table"]),
};

export default CandidateListFilterPrompt;
